import { render, staticRenderFns } from "./ExternalNumberSlider.vue?vue&type=template&id=0a8c0ba5&scoped=true&"
import script from "./ExternalNumberSlider.vue?vue&type=script&lang=js&"
export * from "./ExternalNumberSlider.vue?vue&type=script&lang=js&"
import style0 from "./ExternalNumberSlider.vue?vue&type=style&index=0&id=0a8c0ba5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8c0ba5",
  null
  
)

export default component.exports